import React, { useCallback, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  AccessCert,
  DefaultBlot,
  DefaultGraph,
  EllipseImage,
  LightEllipse,
  MoneyTree,
  MoneyWallet,
  PaperShild,
  RoundGraph,
} from 'src/assets';
import './marketEconomy.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const MarketEconomy = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const renderRowItem = useCallback(
    (image, title, subtitle) => {
      return (
        <div className="market-economy-item-row">
          <img src={image} alt={image} className="market-economy-item-row-image" />
          <div className="market-economy-item-row-content">
            <h3 className="market-economy-item-row-title">{t(title)}</h3>
            <text>{t(subtitle)}</text>
          </div>
        </div>
      );
    },
    [t],
  );

  return (
    <div className="market-economy">
      <div className={`market-economy-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="market-economy-item">
          <img src={RoundGraph} alt={RoundGraph} className="market-economy-item-image" />
          <div className="market-economy-item-content">
            <h2 className="market-economy-item-title">{t('marketEconomy:marketRoleTitle')}</h2>
            <text className="market-economy-item-subtitle">{t('marketEconomy:marketRoleSub')}</text>
            {renderRowItem(PaperShild, 'marketEconomy:security', 'marketEconomy:securitySub')}
            {renderRowItem(MoneyWallet, 'marketEconomy:dividents', 'marketEconomy:dividentsSub')}
          </div>
        </div>
        <div className="market-economy-item item-row-reverse" style={{ paddingBottom: 0 }}>
          <div className="market-economy-item-content" style={{ marginRight: '50px' }}>
            <h2 className="market-economy-item-title">{t('marketEconomy:analysisTitle')}</h2>
            <text className="market-economy-item-subtitle">
              <Trans i18nKey="marketEconomy:analysisSub" />
            </text>
            {renderRowItem(MoneyTree, 'marketEconomy:flexibility', 'marketEconomy:flexibilitySub')}
            {renderRowItem(
              AccessCert,
              'marketEconomy:accessability',
              'marketEconomy:accessabilitySub',
            )}
          </div>
          <img src={DefaultGraph} alt={DefaultGraph} className="market-economy-item-image" />
        </div>

        <img src={LightEllipse} alt={LightEllipse} className="market-economy-image-3" />
        <img src={EllipseImage} alt={EllipseImage} className="market-economy-image-4" />
        <img src={EllipseImage} alt={EllipseImage} className="market-economy-image-5" />
        <img src={DefaultBlot} alt={DefaultBlot} className="market-economy-image-6" />
        <img src={DefaultBlot} alt={DefaultBlot} className="market-economy-image-7" />
      </div>
    </div>
  );
};
